import React from 'react';
import {useI18n} from '../../../../../data/hooks/i18nHooks';
import { useScheduleEnabled } from '../../../../../data/hooks/schedule/useScheduleEnabled';
import StartNetworkingGroup from '../../StartNetworkingGroup';
import StepExhibitors from './StepExhibitors';
import StepSelectableSessions from './StepSelectableSessions';
import StepSpeeddate from './StepSpeeddate';
import StepViewSchedule from './StepViewSchedule';
import icon from './icon.png';
import styles from './ScheduleGroup.module.scss';

function ScheduleGroup(props) {
    const {eventId} = props,
        i18n = useI18n(),
        scheduleEnabled = useScheduleEnabled(eventId);

    return (
        <StartNetworkingGroup
            name={i18n['start.programme']}
            description={i18n['start.programme.intro']}
            visible={scheduleEnabled}
            icon={icon}
            iconClassName={styles.icon}>
            <StepViewSchedule eventId={eventId} />
            <StepSelectableSessions eventId={eventId} />
            <StepSpeeddate eventId={eventId} />
            <StepExhibitors eventId={eventId} />
        </StartNetworkingGroup>
    );
}

export default ScheduleGroup;
